module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/_redefine.js
// module id = 396
// module chunks = 0